import { render, staticRenderFns } from "./paba-technical-error.vue?vue&type=template&id=55f1d0b0&lang=pug"
import script from "./paba-technical-error.vue?vue&type=script&lang=js"
export * from "./paba-technical-error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports